module.exports = __webpack_public_path__ + "img/convoca_asamblea.5d5e6261.jpg";